import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, lastValueFrom } from 'rxjs';
import { BusinessType } from 'src/types';
import { CardPaymentsActivationService } from '../../card-payments-activation/card-payments-activation.service';
import { SettingsCardPaymentsSectionComponent } from 'src/app/components/settings-card-payments-section/settings-card-payments-section.component';
import { RadioButtonGroup } from 'src/app/components/radio-button-group/radio-button-group.component';
import { AdvancedService } from 'src/app/services/advanced/advanced.service';
import { MerchantDetails } from '../interfaces/merchant-details.interface';
import { ShippingAddress } from '../interfaces/shipping-address.interface';
import { SharedModule } from 'src/app/shared.module';

import { advancedPages } from '../advanced-data';
import { CommonModule, Location } from '@angular/common';
import { CtaButtonsComponent } from 'src/app/components/cta-buttons/cta-buttons.component';
import { StarterFormDataService } from '../../starter/starter-form-data.service';
import { error } from 'console';

@Component({
  selector: 'app-business-entity-th',
  standalone: true,
  imports: [
    SettingsCardPaymentsSectionComponent,
    RadioButtonGroup,
    SharedModule,
    CommonModule,
    CtaButtonsComponent,
    SharedModule,
  ],
  templateUrl: './business-entity-th.component.html',
  styleUrl: './business-entity-th.component.scss',
})
export class BusinessEntityThComponent {
  private routerSubscription!: Subscription;
  advancedPages: string[] = advancedPages;
  nextDisabled: boolean = false;
  public isLoading: boolean = false;
  public selectedBusinessType: FormControl = new FormControl();
  public businessTypes: BusinessType[] = [
    {
      value: 'individual',
      urls: [[]],
    },
    {
      value: 'thaiPartnership',
      urls: [
        [],
        [],
        ['../../../../assets/document-samples/business-registration.png'],
        ['../../../../assets/document-samples/shareholders-list.png'],
        [],
      ],
    },
    {
      value: 'thaiLimitedCompany',
      urls: [
        [],
        [],
        ['../../../../assets/document-samples/business-registration.png'],
        ['../../../../assets/document-samples/shareholders-list.png'],
        [],
      ],
    },
    {
      value: 'thaiNonProfit',
      urls: [
        [],
        [],
        ['../../../../assets/document-samples/business-registration.png'],
        ['../../../../assets/document-samples/shareholders-list.png'],
        [],
      ],
    },
    {
      value: 'foreignEntity',
      urls: [
        [],
        [],
        ['../../../../assets/document-samples/business-registration.png'],
      ],
    },
  ];
  public merchantId: number = 0;
  public location = inject(Location);

  constructor(
    private router: Router,
    private cardActivationService: CardPaymentsActivationService,
    private advancedService: AdvancedService,
    private starterService: StarterFormDataService
  ) {}

  onNextPressed = async () => {
    this.isLoading = true;

    const selectedType = this.businessTypes.find(
      (type) => type.value === this.selectedBusinessType.value
    );
    if (selectedType) {
      if (selectedType.value == 'individual') {
        await this.updateShippingAndBusinessName();
        let response = await fetch('/assets/images/1x1.png');
        let data = await response.blob();
        let metadata = {
          type: 'image/png',
        };
        const pobfile = new File([data], 'pob.png', metadata);

        return await lastValueFrom(
          this.advancedService.uploadProofOfBilling(pobfile)
        ).then(
          async (response) => {
            console.log('handleNextClick response pob', response);
            await this.cardActivationService.saveBusinessEntityData(
              selectedType.value
            );
            parent.postMessage(
              JSON.stringify({
                target: '/advanced-manual-success',
              }),
              '*'
            );
            return false;
          },
          (error) => {
            console.error('handleNextClick response pob error:', error);
            return false;
          }
        );
      }

      console.log(selectedType);
      localStorage.setItem(
        'selectedBusinessType',
        JSON.stringify(selectedType)
      );
      localStorage.setItem('businessType', selectedType.value);
      return this.cardActivationService
        .saveBusinessEntityData(selectedType.value)
        .then((results: any) => {
          return true;
        });
    } else {
      return false;
    }
  };

  async ngOnInit() {
    this.nextDisabled = true;
    this.cardActivationService
      .fetchBusinessEntityData()
      .subscribe((data: { business_type: string }) => {
        this.selectedBusinessType.setValue(data.business_type);
      });

    this.selectedBusinessType.valueChanges.subscribe((newValue) => {
      console.log(newValue);
      console.log(this.selectedBusinessType);
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoading = true;
        console.log(this.isLoading);
        const businessType = localStorage.getItem('businessType');
        if (businessType) {
          this.selectedBusinessType.setValue(businessType);
          console.log(this.selectedBusinessType);
        }
        console.log('Navigated to business entity');
        this.isLoading = false;
        console.log(this.isLoading);
      }
    });
  }

  navigateToStoreLinks() {
    this.router.navigate(['/card-activation/store-links']);
  }

  navigateBack() {
    this.location.back();
  }

  async navigateToBusinessDocuments() {
    // this.router.navigate(['/card-activation/business-documents'])
    const selectedType = this.businessTypes.find(
      (type) => type.value === this.selectedBusinessType.value
    );
    if (selectedType) {
      console.log(selectedType);
      localStorage.setItem(
        'selectedBusinessType',
        JSON.stringify(selectedType)
      );
      localStorage.setItem('businessType', selectedType.value);
      this.cardActivationService.saveBusinessEntityData(selectedType.value);
      if (selectedType.value == 'individual') {
        await this.updateShippingAndBusinessName();
        let response = await fetch('/assets/images/1x1.png');
        let data = await response.blob();
        let metadata = {
          type: 'image/png',
        };
        const pobfile = new File([data], 'pob.png', metadata);

        return await lastValueFrom(
          this.advancedService.uploadProofOfBilling(pobfile)
        ).then(
          (response) => {
            console.log('handleNextClick response pob', response);
            parent.postMessage(
              JSON.stringify({
                target: '/advanced-manual-success',
              }),
              '*'
            );
            return;
          },
          (error) => {
            console.error('handleNextClick response pob error:', error);
            return;
          }
        );
      } else this.router.navigate(['/advanced/business-info']);
    }
  }

  private updateShippingAndBusinessName = async () => {
    const userId = localStorage.getItem('userId');

    if (!userId) {
      throw Error('[ADVANCED] User ID is not found in localStorage');
    }

    this.merchantId = parseInt(userId, 10);

    try {
      const merchantDetails = (await this.advancedService.getMerchantDetails(
        this.merchantId
      )) as MerchantDetails;

      if (!merchantDetails) {
        return;
      }

      const { shipping_address, business_name, shop_name } = merchantDetails;

      const selectedType = this.businessTypes.find(
        (type) => type.value === this.selectedBusinessType.value
      );

      if (
        (!shipping_address || !business_name) &&
        selectedType?.value != 'individual'
      ) {
        return;
      }

      await this.advancedService.updateBusinessAddress({
        business_name: business_name ? (business_name as string) : shop_name,
        line_1: shipping_address['line_1'],
        barangay: shipping_address['barangay'],
        city: shipping_address['city'],
        province: shipping_address['province'],
        postal_code: shipping_address['postal_code'],
      });

      const storeData = {
        store: {
          shop_name: shop_name,
          is_whole_day: this.starterService.shopBusinessHours?.take_order_status?.is_whole_day
        },
        business_tax_id: '0',
      };

      await this.starterService
        .updateStoreDetails(storeData)
        .subscribe((data) => {
          console.log(data);
        });

      await lastValueFrom(this.advancedService.activateNonCOD());
    } catch (error) {
      console.error('[ADVANCED] Error fetching merchant details: ', error);
    }
  };
}
